import {useQuery} from '@tanstack/react-query';
import {FavoriteAddressesItem} from '../types';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getFavoriteAddresses} from '../services/getFavoriteAddresses';
import {UseGetFavoriteAddressesQueryParams} from './types';
import {useAccountInformation} from 'presentation/pages/private/hooks';

export function useGetFavoriteAddressesQuery({
	enabled = true,
}: UseGetFavoriteAddressesQueryParams = {}) {
	const {isHolder} = useAccountInformation();
	return useQuery<FavoriteAddressesItem[]>({
		queryKey: [QUERY_KEYS.PROFILE_FAVORITE_ADDRESSES, isHolder],
		queryFn: ({signal}) => getFavoriteAddresses({signal, isHolder}),
		enabled,
	});
}
